<template>
  <div v-if="isOpen" class="publish-url-overlay" @mousedown="handleOverlayMouseDown" @mouseup="handleOverlayMouseUp">
    <div class="publish-url-content" @mousedown="handleContentMouseDown">
      <h3 class="publish-url-title">{{ modalTitle }}</h3>

      <div class="publish-url-body">
        <p class="publish-url-description">
          以下のURLで誰でもブックマークを閲覧できます。<br>
          PINコードは不要です。
        </p>

        <!-- 複数の公開URL -->
        <template v-if="publishedPagesList && publishedPagesList.length > 1">
          <div v-for="(page, index) in publishedPagesList" :key="page.cloudId" class="url-entry">
            <div v-if="page.pageName" class="url-page-name">{{ page.pageName }}</div>
            <div v-else class="url-page-name">ページ {{ index + 1 }}</div>
            <div class="url-container">
              <div class="url-display">{{ page.publishUrl }}</div>
              <button class="copy-button" @click="copyPageUrl(page.publishUrl, index)">
                {{ copiedIndex === index ? 'コピー完了' : 'コピー' }}
              </button>
            </div>
          </div>
        </template>

        <!-- 単一の公開URL -->
        <template v-else>
          <div class="url-container">
            <div class="url-display">{{ displayUrl }}</div>
            <button class="copy-button" @click="copyToClipboard">
              {{ copyStatus === 'copied' ? 'コピー完了' : 'コピー' }}
            </button>
          </div>
        </template>

        <div class="publish-info">
          <div class="info-icon">
            <v-icon size="20" color="#e9937d">mdi-information-outline</v-icon>
          </div>
          <div class="info-text">
            公開を停止するには、バーガーメニューから「公開中のブクマすを非公開にする」を選択してください。
          </div>
        </div>
      </div>

      <div class="publish-url-footer">
        <button class="publish-url-close-button" @click="close">閉じる</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PublishUrlModal',
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    publishUrl: {
      type: String,
      default: ''
    },
    publishedPagesList: {
      type: Array,
      default: () => []
    }
  },
  emits: ['close'],
  data() {
    return {
      copyStatus: 'ready',
      copiedIndex: -1,
      mouseDownOnOverlay: false
    };
  },
  computed: {
    modalTitle() {
      const count = this.publishedPagesList ? this.publishedPagesList.length : 0;
      if (count > 1) {
        return `公開中のブクマす（${count}件）`;
      }
      return '公開中のブクマすURL';
    },
    displayUrl() {
      if (this.publishedPagesList && this.publishedPagesList.length === 1) {
        return this.publishedPagesList[0].publishUrl;
      }
      return this.publishUrl;
    }
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        this.copyStatus = 'ready';
        this.copiedIndex = -1;
      }
    }
  },
  methods: {
    copyToClipboard() {
      const url = this.displayUrl;
      if (!url) return;
      try {
        navigator.clipboard.writeText(url).then(() => {
          this.copyStatus = 'copied';
          setTimeout(() => { this.copyStatus = 'ready'; }, 2000);
        });
      } catch (error) {
        console.error('クリップボードへのコピーに失敗しました', error);
      }
    },
    copyPageUrl(url, index) {
      if (!url) return;
      try {
        navigator.clipboard.writeText(url).then(() => {
          this.copiedIndex = index;
          setTimeout(() => { this.copiedIndex = -1; }, 2000);
        });
      } catch (error) {
        console.error('クリップボードへのコピーに失敗しました', error);
      }
    },
    close() {
      this.$emit('close');
    },
    handleOverlayMouseDown(e) {
      this.mouseDownOnOverlay = e.target.classList.contains('publish-url-overlay');
    },
    handleOverlayMouseUp(e) {
      if (this.mouseDownOnOverlay && e.target.classList.contains('publish-url-overlay')) {
        this.close();
      }
      this.mouseDownOnOverlay = false;
    },
    handleContentMouseDown() {
      this.mouseDownOnOverlay = false;
    }
  }
};
</script>

<style scoped>
.publish-url-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1200;
}
.publish-url-content {
  background-color: white;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}
.publish-url-title {
  color: #333;
  margin-top: 0;
  border-bottom: 1px solid #eee;
  padding-bottom: 12px;
}
.publish-url-description {
  font-size: 0.95rem;
  line-height: 1.5;
  color: #555;
  margin-bottom: 20px;
}
.url-container {
  display: flex;
  align-items: center;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 20px;
}
.url-entry {
  margin-bottom: 8px;
}
.url-entry .url-container {
  margin-bottom: 0;
}
.url-entry:last-child {
  margin-bottom: 20px;
}
.url-page-name {
  font-size: 0.85rem;
  font-weight: 500;
  color: #666;
  margin-bottom: 4px;
  padding-left: 2px;
}
.url-display {
  flex: 1;
  padding: 10px;
  background-color: #f8f8f8;
  font-family: monospace;
  font-size: 0.88rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.copy-button {
  background-color: #e9d0ca;
  border: none;
  color: #333;
  padding: 10px 15px;
  cursor: pointer;
  transition: background-color 0.2s;
  white-space: nowrap;
  font-weight: 500;
}
.copy-button:hover {
  background-color: #e0c0b8;
}
.publish-info {
  display: flex;
  gap: 10px;
  background-color: #f8f8f8;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 20px;
}
.info-text {
  font-size: 0.88rem;
  line-height: 1.5;
  color: #666;
}
.publish-url-footer {
  display: flex;
  justify-content: center;
}
.publish-url-close-button {
  background-color: #e9d0ca;
  color: #333;
  border: none;
  border-radius: 50px;
  padding: 10px 30px;
  font-size: 0.95rem;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s;
}
.publish-url-close-button:hover {
  background-color: #d9b6ab;
}

@media (max-width: 600px) {
  .publish-url-content {
    padding: 20px;
  }
}
</style>
